import zhCn from 'gregorian-calendar-format/lib/locale/zh_CN';
import zhCnCalendar from 'gregorian-calendar/lib/locale/zh_CN';

export default {
  clear: '清除',
  format: zhCn,
  calendar: zhCnCalendar,
};



// WEBPACK FOOTER //
// ./_rc-time-picker-1.1.6/src/locale/zh_CN.js